import { useTranslation } from "react-i18next";

interface SyncErrorProps {
  code?: any;
  message: string;
}

interface ProductProps {
  itemId: string;
  thumbnail: string;
  largeThumbnail: string;
}

interface AlertProps {
  syncError: SyncErrorProps;
  portalUrl: string;
  productDetails: ProductProps;
}

export default function Warning({
  syncError,
  portalUrl,
  productDetails,
}: AlertProps) {
  const { t } = useTranslation("common");

  return (
    <div className="warning-message">
      {syncError.code !== undefined && syncError.code === "NoPurchase" ? (
        <div className="purchase-thumbnail">
          <img
            src={`${portalUrl}/content/listings/${productDetails.itemId}/info/${
              productDetails.largeThumbnail || productDetails.thumbnail
            }`}
            alt="thumbnail"
          />
        </div>
      ) : null}
      <div className="bg-white px-4 pt-12 pb-12">
        <div className="sm:flex sm:items-start sm:justify-center">
          <div className="mx-auto flex-shrink-0 flex justify-center h-12 w-12 sm:mx-0 sm:h-10 sm:w-10">
            <svg width="24" height="24">
              <path d="M1.225 21.225A1.678 1.678 0 0 0 2.707 22H22.28a1.68 1.68 0 0 0 1.484-.775 1.608 1.608 0 0 0 .003-1.656L13.995 1.827a1.745 1.745 0 0 0-2.969 0l-9.8 17.742a1.603 1.603 0 0 0 0 1.656zm.859-1.143l9.82-17.773A.71.71 0 0 1 12.508 2a.73.73 0 0 1 .629.342l9.751 17.708a.626.626 0 0 1 .017.662.725.725 0 0 1-.626.288H2.708a.723.723 0 0 1-.623-.286.605.605 0 0 1-.001-.632zM13 15h-1V8h1zm-1.5 2.5a1 1 0 1 1 1 1 1.002 1.002 0 0 1-1-1z"></path>
            </svg>
          </div>
          <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3
              className="text-lg leading-6 font-medium text-gray-900"
              id="modal-headline"
            >
              {syncError.code !== undefined &&
              syncError.code === "NoPurchase" ? (
                <>{syncError.message}</>
              ) : (
                <p>An unexpected error occurred</p>
              )}
            </h3>
            <div className="mt-2">
              <p className="text-sm text-gray-500">
                {syncError.code !== undefined &&
                syncError.code === "NoPurchase" ? (
                  <>{syncError.message}</>
                ) : (
                  <p>Please try again</p>
                )}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
